import axios from '@/utils/axios';

const apiUrl = {
  getMediaRebateList: '/mediaIndustry/getList', //获取所有行业的返点信息用于列表展示
  saveMediaRebate: '/mediaIndustry/save', //保存行业的返点信息
  updateMediaRebate: '/mediaIndustry/update', //修改行业的返点信息
  deleteMediaRebate: '/mediaIndustry/delete', //删除行业的返点信息
};

export function getMediaRebateList(params) {
  return axios.post(apiUrl.getMediaRebateList, params);
}
export function saveMediaRebate(params) {
  return axios.post(apiUrl.saveMediaRebate, params);
}
export function updateMediaRebate(params) {
  return axios.post(apiUrl.updateMediaRebate, params);
}
export function deleteMediaRebate(params) {
  return axios.post(apiUrl.deleteMediaRebate, params);
}
